/**
 * This listens for a toggle on the b2b checkout between private/individual. If the toggle is changed the
 * available payment methods will be changed.
 *
 * TODO: I might need to listen for the event using jQuery on updated_checkout because WC changes the checkout page
 * after this event, and we need to change the available payment gateways after the toggle is changed.
 *
 */
import {
	setCookie,
	getCookie,
} from '.././helpers';

const paymentInput = jQuery( 'input[name="payment_method"]' );

/**
 * Quickfix for Klarna not adding its layout class when switching payment methods using the checkout toggle.
 * This is tempoaray and should be remedied in the future as it limits us to not being able to use the column setting from Klarna.
 */
if ( paymentInput.val() === 'kco' ) {
	jQuery( 'body' ).addClass( 'kco-one-selected' );
}

jQuery( document ).ready( function() {
	const checkoutToggle = document.getElementById( 'checkout_toggle' );

	if ( checkoutToggle ) {
		if ( getCookie( 'ac_checkout_toggle' ) ) {
			checkoutToggle.checked = true;
		}

		checkoutToggle.addEventListener( 'change', function( e ) {
			e.preventDefault();
			if ( this.checked ) {
			// For the company side of the toggle.
				setCookie( 'ac_checkout_toggle', true );
			} else {
			// For the private individual side of the toggle.
				setCookie( 'ac_checkout_toggle', '', -1 );
			}

			paymentInput.trigger( 'change' );
		} );
	}
} );
